window.addEventListener('DOMContentLoaded', () => {
    
    //NEW MENU
    let menuFirstElements = document.body.querySelectorAll('#main-menu > li > a');
    // let innerWidth = window.innerWidth;
    let closeMenuButton = document.body.querySelector('span.close-menu');
    
    closeMenuButton.addEventListener('click', ( e ) => {

        if( window.innerWidth < 991 ){
            e.preventDefault();
            document.getElementById('container-mm-menu').classList.remove( 'open');
            document.body.style.overflow = '';
            let closeMenuEvent = new Event('dp-menu-close');
            document.dispatchEvent( closeMenuEvent );
        }

    });
    document.getElementById('menu-phone').addEventListener('click', () => {
        document.body.style.overflow='hidden';
    });
    /** DEFAULT ELEME START */
    let menuTriggers = document.body.querySelectorAll('.nav-bar-mobile-f .menu-item-has-children.default-item > a');
    
    [...menuTriggers].map( elem => {
        elem.addEventListener( 'click',e => {
            e.preventDefault();
            let submenu = elem.parentElement.querySelector('ul.sub-menu');
            submenu.classList.add('active');
        });
    });

    let prevMenu = document.body.querySelectorAll('.default-item .sub-menu .return-mm');
    [...prevMenu].map( elem => {
        elem.addEventListener('click', ( e ) => {
            elem.parentNode.classList.remove('active');
        });
    });

    document.addEventListener('dp-menu-close', () => {
        [...prevMenu].map( elem => {    
            elem.parentNode.classList.remove('active');
        });
    });

    /** DEFAULT ELEME END */
    [...menuFirstElements].forEach( elem => {
        
        if( elem.parentNode.querySelector('.dp-mega-menu') ){
            
            // Main handler
            elem.addEventListener('click', function( e ){
                if( window.innerWidth < 991 ){
                    e.preventDefault();
                    elem.parentNode.querySelector('.dp-mega-menu').classList.add('active');
                }
            });
            
            elem.parentNode.querySelector('.dp-mega-menu .return-mm').addEventListener( 'click', () => {
                if( window.innerWidth < 991 ){
                    elem.parentNode.querySelector('.dp-mega-menu').classList.remove('active');
                }
            });

            //sub item handler
            let subItems = elem.parentNode.querySelectorAll('a.sub-items');
            
            [...subItems].forEach( elem => {
                elem.addEventListener('click', (e) => {
                    
                    if( window.innerWidth < 991 ){

                        if( elem.classList.contains('no-sub-mobile') ){
                         
                        } else {
                            e.preventDefault();
                            elem.parentNode.querySelector('.mm-sub').classList.add('active');
                        }

                    }
                });

                returnElem = elem.parentNode.querySelector('.return-mm');
                returnElem.addEventListener('click', () => {
                    elem.parentNode.querySelector('.mm-sub').classList.remove('active');
                });

            });


        }
    });

    let nodes = document.body.querySelectorAll('.action-click');


    for( let i=0 ; i < nodes.length; i++ ){
        let node = nodes[i];
        node.addEventListener('click', ( e ) => {
            e.stopPropagation();
            
            if( e.currentTarget.getAttribute('action') == 'toggleClass' ){
                let targetNode = document.querySelector( e.currentTarget.getAttribute('action-target') );
                let value = e.currentTarget.getAttribute('action-value');
                // if( !targetNode.classList.toggle( value )){
                //     document.getElementById('menu-top-holder-phone').style.left="0";    
                // }
            }

            // if( document.getElementById('container-phone-menu').classList.contains('open')){
            //     document.body.style.overflow ='hidden';
            // } else {
            //     document.body.style.overflow ='';
            // }


        })
    }

});

window.addEventListener('DOMContentLoaded', () => {
    
    let quantity = document.querySelectorAll('.quantity');
    console.log( quantity );
    [...quantity].forEach( elem => {
        
        let minus = elem.querySelector('.minus');
        let plus = elem.querySelector('.plus');
        let value = elem.querySelector('input.qty');
        
        // jQuery(value).prop('disabled', true);
        jQuery(minus).on('click', function(){
            if (jQuery(value).val() <= 1) {
                jQuery(value).val(1);
            } else {
                jQuery(value).val( parseInt(jQuery(value).val()) - 1 );
                jQuery(value).trigger('change');
                setTimeout( function () {
                    // jQuery('form.woocommerce-cart-form').trigger('submit');
                    // jQuery(document.body).trigger('wc_update_cart');
                }, 2000);
            }
        });
        jQuery(plus).on('click', function(){
            jQuery(value).val( parseInt(jQuery(value).val()) + 1 );
            jQuery(value).trigger('change');
            // jQuery(document.body).trigger('wc_update_cart');
        });

    });
    // $(document).ready(function(){
    //     $('.count').prop('disabled', true);
    //        $(document).on('click','.plus',function(){
    //         $('.count').val(parseInt($('.count').val()) + 1 );
    //     });
    //     $(document).on('click','.minus',function(){
    //         $('.count').val(parseInt($('.count').val()) - 1 );
    //             if ($('.count').val() == 0) {
    //                 $('.count').val(1);
    //             }
    //         });
    //  });   
});

window.addEventListener('DOMContentLoaded', () => {

    let nodes = document.body.querySelectorAll('.action-click');

    for( let i=0 ; i < nodes.length; i++ ){
        let node = nodes[i];
        node.addEventListener('click', ( e ) => {
            e.stopPropagation();
            
            if( e.currentTarget.getAttribute('action') == 'toggleClass' ){
                let targetNode = document.querySelector( e.currentTarget.getAttribute('action-target') );
                let value = e.currentTarget.getAttribute('action-value');
                if( !targetNode.classList.toggle( value )){
                    // document.getElementById('menu-top-holder-phone').style.left="0";    
                }
            }

            // if( document.getElementById('container-phone-menu').classList.contains('open')){
            //     document.body.style.overflow ='hidden';
            // } else {
            //     document.body.style.overflow ='';
            // }


        })
    }
    
    [...document.querySelectorAll('.item-slider')].forEach( slider => {
        
        jQuery(slider.querySelector('.collections-slider')).slick({
            infinite: false,
            swipeToSlide:true,
            variableWidth: true,
            prevArrow:slider.querySelector('.slick-prev'),
            nextArrow:slider.querySelector('.slick-next'),
        });

    });

    let halfmodalToggler = document.querySelector('.halfmodal-title');
    if( halfmodalToggler ){
        halfmodalToggler.addEventListener('click', () => {
            document.querySelector('.halfmodal').classList.toggle('open');
        });
    }

    let filterOpeners = document.querySelectorAll('.halfmodal .filters h5');
    if( filterOpeners ){
        [...filterOpeners].forEach(element => {
            element.addEventListener( 'click', ( e ) => {
                e.stopPropagation();
                element.classList.toggle( 'open' );
            }); 
        });
    }

});

